import { Component, Input } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { ngxCsv } from 'ngx-csv';

@Component({
  selector: 'app-report-inventory',
  template: `
    <p>
      report-inventory works!
    </p>
  `,
  styles: [
  ]
})
export class ReportInventoryComponent {
  @Input() profile: any;

  constructor(
    private store: SettlementsService
  ) { }

  ngOnInit(): void {
  }

  generateReport(date_from: any, date_to: any) {
    console.log('GENERATE REPORT');
    this.store.getTanqueReport({ 
      profile_id: this.profile.id,
      created_at_since: date_from,
      created_at_to: date_to
    }).subscribe((data: any) => {
      console.log("REPORT => ", data);
    
      let options = {
        title: 'Reporte de inventario',
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        noDownload: false,
        showTitle: true,
        useBom: true,
        headers: [
          "Nombre",
          "Capacidad",
          "Condominio",
          "Edificio",
          "Lectura",
          "Fecha",
          "Estimación"
        ]
      };

      new ngxCsv(data, 'reporte-inventario', options);
    });
  }

}
